import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import client from '../api/client';
import PageLayout from '../components/PageLayout';
import Card from '../components/Card';
import Button from '../components/Button';

const ROLE_LABEL = {
  superadmin: '超级管理员',
  admin: '系统管理员',
  enterprise_admin: '企业管理员',
};

function getRoleLabel(user) {
  if (ROLE_LABEL[user.role]) return ROLE_LABEL[user.role];
  // personal role: distinguish enterprise employee vs individual
  return user.enterprise_name ? '企业用户' : '个人用户';
}

export default function ProfilePage() {
  const { user, logout, sso } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  // V5/M6b：只读展示极简画像（昵称 / 岗位 / 行业 / AI 使用目的）
  useEffect(() => {
    client.get('/profile/').then(r => setProfile(r.data)).catch(() => {});
  }, []);

  const handleLogout = async () => { await logout(); if (!sso.enabled) navigate('/'); };
  if (!user) return null;

  return (
    <PageLayout>
      <div style={{maxWidth:560,margin:'0 auto',padding:'48px 20px'}}>
        <h1 style={{fontSize:24,fontWeight:700,marginBottom:32}}>个人中心</h1>
        <Card style={{marginBottom:16}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
            {[
              {label:'显示名称',val:user.display_name},
              {label:'邮箱',val:user.email || '未绑定邮箱'},
              {label:'账号角色',val:getRoleLabel(user)},
              {label:'企业归属',val:user.enterprise_name||'—'},
              {label:'昵称',val:profile?.nickname || '未填写'},
              {label:'职位头衔',val:profile?.position || '未填写'},
              {label:'行业',val:profile?.industry || '未填写'},
              {label:'AI 使用目的',val:profile?.ai_usage_purpose || '未填写'},
            ].map(i=>(
              <div key={i.label} style={{background:'var(--color-bg-page)',borderRadius:'var(--radius-sm)',padding:'14px 16px'}}>
                <div style={{fontSize:12,color:'var(--color-text-muted)',marginBottom:4}}>{i.label}</div>
                <div style={{fontWeight:600,fontSize:15}}>{i.val}</div>
              </div>
            ))}
          </div>
        </Card>
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {sso.enabled && <a href={sso.account_url}>账号设置</a>}
          <Button variant="primary" fullWidth onClick={()=>navigate('/')}>返回首页</Button>
          <Button variant="secondary" fullWidth onClick={()=>navigate('/history')}>查看历史测评记录</Button>
          <Button variant="secondary" fullWidth onClick={()=>navigate('/profile/setup')}>
            修改基础信息
          </Button>
          {!user.enterprise_name && user.role === 'personal' && (
            <Button variant="secondary" fullWidth onClick={()=>navigate('/enterprise/register')}>申请企业注册</Button>
          )}
          {['admin','superadmin','enterprise_admin'].includes(user.role) && (
            <Button variant="secondary" fullWidth onClick={()=>navigate('/admin')}>进入管理后台</Button>
          )}
          <Button variant="ghost" fullWidth onClick={handleLogout} style={{color:'var(--color-error)',border:'1.5px solid var(--color-error)'}}>退出登录</Button>
        </div>
      </div>
    </PageLayout>
  );
}
